import { useContext, useEffect } from 'react'
import UploadFiles from './UploadFiles'
import { useNavigate } from 'react-router-dom'
import { MainContext } from '../MainContext'

const FileCard = props => {
  const navigate = useNavigate()
  const { user, reimbursementItem } = useContext(MainContext)

  function reimbursementItemReceipts(dataResponse) {
    navigate('/Review')
  }

  useEffect(() => {
    if (Object.keys(user).length === 0) {
      return navigate('/')
    }
  }, [])
  if (Object.keys(user).length === 0) {
    return navigate('/')
  }
  return (
    <div className="pt-9">
      <div className="capitalize">Please Upload Receipt Files</div>
      <UploadFiles
        userId={user.id}
        reimbursementItem={reimbursementItem}
        reimbursementItemReceipts={reimbursementItemReceipts}
      />
    </div>
  )
}

export default FileCard
